import React from "react";
import "../Css/PlatimumFamily.css";
import { Link } from "react-router-dom";
import { Container } from "react-bootstrap";

const PlatinumFamily = () => {
  return (
    <React.Fragment>
      <div className="platimumFamilyDiv">
        <Container>
        <div className="sucessTitle platinumFamailyTitle">Join the Platinum Family Today!</div>
        <div className="FamilyDiv">

     
        <div className="platinumFamilyDescription">
          {/* Become part of a vibrant community dedicated to meaningful
          connections. Our personalized approach and expert guidance are here to
          support you in finding your perfect match. Your journey to love starts
          with us! */}
           We’ve guided many people in finding their ideal partners. Let us help you 
           discover your perfect match and make love a reality.
        </div>
        
        </div>
        <div className="contactFamilyDIv">
        <Link to="/contact-us" className="faimlyContactBtn">
        Contact Us
        </Link>
        </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PlatinumFamily;
